import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { Color, IconLocation, Size, Variant } from './button.component';
import { IconComponent } from '../icon/icon.component';

export type LinkTarget = '_self' | '_blank';

@Component({
  standalone: true,
  selector: 'capra-button-link',
  imports: [CommonModule, IconComponent],
  templateUrl: './button-link.component.html',
  styleUrls: ['./button.component.scss', './button-link.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonLinkComponent {
  @Input() href = '';
  @Input() text = '';
  @Input() target: LinkTarget = '_blank';
  @Input() ariaLabel: string | null = null;
  @Input() size: Size = 'medium';
  @Input() variant: Variant = 'primary';
  @Input() color: Color = 'default';
  @Input() icon: string | null = null;
  @Input() iconLocation: IconLocation = 'left';
  @Input() disabled = false;
}
